// Display order of block categories in admin sidebar/picker.
export const BLOCK_CATEGORY_ORDER = ['layout', 'header', 'carousel', 'features', 'cta', 'footer', 'content'];
